module.exports = __webpack_public_path__ + "static/media/YF24_3.aba46ff6.jpg";